import type { IndividualProductCardProps } from "@product-details/components/ComprehensiveProductCard";

export type Teaser = Omit<
  IndividualProductCardProps,
  "leftBadge" | "hideLeftBadge" | "leftBadgeIcon" | "leftBadgeDark"
> & {
  hideCustomBadge: boolean;
  customBadge?: string;
  customBadgeIcon?: string;
  customBadgeDark: boolean;
};
